"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Race = exports.Gender = void 0;
var Gender;
(function (Gender) {
    Gender["Male"] = "Male";
    Gender["Female"] = "Female";
})(Gender = exports.Gender || (exports.Gender = {}));
var Race;
(function (Race) {
    Race["Human"] = "Human";
    Race["Dwarf"] = "Dwarf";
    Race["Elf"] = "Elf";
    Race["Halfling"] = "Halfling";
})(Race = exports.Race || (exports.Race = {}));
//# sourceMappingURL=domain.js.map